/* Menoir wishlist (22 Oct 2026 client list, item 6). Saved in the shopper's browser (localStorage),
   no app and no login needed. Hearts on every product card and on the product page; the list lives
   at /collections/all?view=wishlist. */
(function () {
  var KEY = 'mn-wishlist';
  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M12 20.3s-7.8-4.6-7.8-10.3A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.8 2.4c0 5.7-7.8 10.3-7.8 10.3Z"/></svg>';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(l) { localStorage.setItem(KEY, JSON.stringify(l)); sync(); document.dispatchEvent(new CustomEvent('mn:wishlist', { detail: l })); }
  function has(h) { return read().indexOf(h) > -1; }
  function toggle(h) { var l = read(), i = l.indexOf(h); if (i > -1) l.splice(i, 1); else l.unshift(h); write(l); return i === -1; }
  function handleOf(href) { var m = (href || '').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null; }

  function sync() {
    var n = read().length;
    document.querySelectorAll('[data-mn-wl-count]').forEach(function (el) { var t = el.querySelector('[data-mn-wl-num]') || el; if (t.textContent !== String(n)) t.textContent = n; if (el.hidden !== (n === 0)) el.hidden = n === 0; });
    document.querySelectorAll('[data-mn-wl]').forEach(function (b) {
      var on = has(b.getAttribute('data-mn-wl'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
      var t = b.querySelector('[data-mn-wl-label]'), txt = on ? 'Saved to wishlist' : 'Add to wishlist';
      if (t && t.textContent !== txt) t.textContent = txt;
    });
  }

  function decorateCards(root) {
    (root || document).querySelectorAll('a.mn-loved__card').forEach(function (a) {
      var media = a.querySelector('.mn-loved__media'); var h = handleOf(a.getAttribute('href'));
      if (!media || !h || a.parentNode.querySelector(':scope > .mn-wl-btn')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mn-wl-btn'; b.setAttribute('data-mn-wl', h); b.setAttribute('aria-label', 'Save to wishlist'); b.innerHTML = HEART;
      var host = a.parentNode; if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      host.appendChild(b);
    });
  }

  function decorateProduct() {
    var h = handleOf(location.pathname); if (!h) return;
    var form = document.querySelector('.product-information form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form || document.querySelector('.mn-wl-pdp')) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mn-wl-pdp'; b.setAttribute('data-mn-wl', h);
    b.innerHTML = HEART + '<span data-mn-wl-label>Add to wishlist</span>';
    form.parentNode.insertBefore(b, form.nextSibling);
  }

  function money(cents) { return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-IN'); }
  function renderPage() {
    var grid = document.querySelector('[data-mn-wl-grid]'); if (!grid) return;
    var empty = document.querySelector('[data-mn-wl-empty]');
    var list = read();
    if (empty) empty.hidden = list.length > 0;
    grid.innerHTML = '';
    list.forEach(function (h) {
      var li = document.createElement('li'); li.className = 'mn-wl-item'; li.style.position = 'relative'; grid.appendChild(li);
      fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=900' : '';
        li.innerHTML = '<a class="mn-loved__card" href="/products/' + p.handle + '"><span class="mn-loved__media">' +
          (img ? '<img class="mn-loved__img" src="' + img + '" alt="" loading="lazy">' : '') +
          '</span><span class="mn-loved__name">' + p.title + '</span><span class="mn-loved__price">' + money(p.price) + '</span></a>';
        decorateCards(li); sync();
      }).catch(function () { var l = read(); l.splice(l.indexOf(h), 1); localStorage.setItem(KEY, JSON.stringify(l)); li.remove(); sync(); });
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mn-wl]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var added = toggle(b.getAttribute('data-mn-wl'));
    b.classList.remove('is-pop'); void b.offsetWidth; if (added) b.classList.add('is-pop');
    if (!added && b.closest('[data-mn-wl-grid]')) renderPage();
  }, true);

  function init() { decorateCards(); decorateProduct(); renderPage(); sync(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // New cards (filters, infinite scroll, related slider) get hearts too; batched so our own writes can't loop
  var queued = false;
  new MutationObserver(function () {
    if (queued) return; queued = true;
    requestAnimationFrame(function () { queued = false; decorateCards(); decorateProduct(); sync(); });
  }).observe(document.body, { childList: true, subtree: true });
  window.addEventListener('storage', function (e) { if (e.key === KEY) { sync(); renderPage(); } });
})();
